import React from 'react';
import { createStylesHook } from 'shared/hooks';
import { palettes } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';

const useStyles = createStylesHook(() => ({
  content: {
    backgroundColor: palettes.brand.gray['100'],
    color: palettes.brand.gray['800'],
    padding: '0 10px',
    borderRadius: 4,
    fontSize: '0.875rem',
    lineHeight: 1,
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    overflow: 'hidden'
  },
  label: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  anchor: {
    display: 'flex',
    lineHeight: 1.1,
    color: palettes.brand.blue.base
  }
}));

interface FileTagProps {
  link: string;
  label: string;
  onDelete?: () => void;
}

export const FileTag: React.FunctionComponent<FileTagProps> = ({ label, link, onDelete }): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <a href={link} target="_blank" rel="noopener noreferrer" className={classes.anchor}>
        <FontAwesomeIcon icon={faPaperclip} color={palettes.brand.blue.base} style={{ marginRight: 8, width: 12 }} />
        <div className={classes.label}>{label}</div>
      </a>
      {onDelete && (
        <FontAwesomeIcon
          icon={faTrash}
          color={palettes.brand.red.dark}
          style={{ marginLeft: 10, width: 10, cursor: 'pointer' }}
          onClick={onDelete}
        />
      )}
    </div>
  );
};
